import * as web3Utils from 'web3-utils';
export const isoToUnix = (date) => (String((new Date(date + 'Z')).getTime() / 1000));
export const unixToISO = (unix) => (new Date(Number(unix) * 1000).toISOString());
export const toHex = (mixed) => ((String(mixed).startsWith('0x')) ? mixed : web3Utils.toHex(mixed));
export const hexToUtf8 = (hex) => (web3Utils.hexToAscii(hex));
export const toChecksumAddress = (address) => (web3Utils.toChecksumAddress(address));
export const toPrecision = (number) => (web3Utils.toWei((typeof number === 'string') ? number : number.toString()));
export const fromPrecision = (number) => (web3Utils.fromWei((typeof number === 'string') ? number : number.toString()));
export const encodeAsBytes32 = (externalData) => (web3Utils.padLeft(web3Utils.toHex(externalData), 64));
export const decodeBytes32AsNumber = (bytes32Data) => (web3Utils.hexToNumberString(bytes32Data));
export const decodeBytes32AsAddress = (bytes32) => {
    if (bytes32.length !== 66) {
        throw new Error('Invalid bytes32 value ' + bytes32);
    }
    return '0x' + bytes32.substring(26);
};
export const parseWeb3Response = (web3Response) => associativeArrayToObject(web3Response);
export const extractANNTerms = (terms) => ({
    contractType: terms.contractType,
    calendar: terms.calendar,
    contractRole: terms.contractRole,
    dayCountConvention: terms.dayCountConvention,
    businessDayConvention: terms.businessDayConvention,
    endOfMonthConvention: terms.endOfMonthConvention,
    scalingEffect: terms.scalingEffect,
    feeBasis: terms.feeBasis,
    currency: terms.currency,
    settlementCurrency: terms.settlementCurrency,
    marketObjectCodeRateReset: terms.marketObjectCodeRateReset,
    statusDate: terms.statusDate,
    initialExchangeDate: terms.initialExchangeDate,
    maturityDate: terms.maturityDate,
    issueDate: terms.issueDate,
    purchaseDate: terms.purchaseDate,
    capitalizationEndDate: terms.capitalizationEndDate,
    cycleAnchorDateOfInterestPayment: terms.cycleAnchorDateOfInterestPayment,
    cycleAnchorDateOfRateReset: terms.cycleAnchorDateOfRateReset,
    cycleAnchorDateOfScalingIndex: terms.cycleAnchorDateOfScalingIndex,
    cycleAnchorDateOfFee: terms.cycleAnchorDateOfFee,
    cycleAnchorDateOfPrincipalRedemption: terms.cycleAnchorDateOfPrincipalRedemption,
    notionalPrincipal: terms.notionalPrincipal,
    nominalInterestRate: terms.nominalInterestRate,
    accruedInterest: terms.accruedInterest,
    rateMultiplier: terms.rateMultiplier,
    rateSpread: terms.rateSpread,
    nextResetRate: terms.nextResetRate,
    feeRate: terms.feeRate,
    feeAccrued: terms.feeAccrued,
    premiumDiscountAtIED: terms.premiumDiscountAtIED,
    priceAtPurchaseDate: terms.priceAtPurchaseDate,
    priceAtTerminationDate: terms.priceAtTerminationDate,
    nextPrincipalRedemptionPayment: terms.nextPrincipalRedemptionPayment,
    lifeCap: terms.lifeCap,
    lifeFloor: terms.lifeFloor,
    periodCap: terms.periodCap,
    periodFloor: terms.periodFloor,
    gracePeriod: terms.gracePeriod,
    delinquencyPeriod: terms.delinquencyPeriod,
    cycleOfInterestPayment: terms.cycleOfInterestPayment,
    cycleOfRateReset: terms.cycleOfRateReset,
    cycleOfScalingIndex: terms.cycleOfScalingIndex,
    cycleOfFee: terms.cycleOfFee,
    cycleOfPrincipalRedemption: terms.cycleOfPrincipalRedemption
});
export const extractCECTerms = (terms) => ({
    contractType: terms.contractType,
    calendar: terms.calendar,
    contractRole: terms.contractRole,
    dayCountConvention: terms.dayCountConvention,
    businessDayConvention: terms.businessDayConvention,
    endOfMonthConvention: terms.endOfMonthConvention,
    feeBasis: terms.feeBasis,
    creditEventTypeCovered: terms.creditEventTypeCovered,
    statusDate: terms.statusDate,
    maturityDate: terms.maturityDate,
    notionalPrincipal: terms.notionalPrincipal,
    feeRate: terms.feeRate,
    coverageOfCreditEnhancement: terms.coverageOfCreditEnhancement,
    contractReference_1: terms.contractReference_1,
    contractReference_2: terms.contractReference_2
});
export const extractCEGTerms = (terms) => ({
    contractType: terms.contractType,
    calendar: terms.calendar,
    contractRole: terms.contractRole,
    dayCountConvention: terms.dayCountConvention,
    businessDayConvention: terms.businessDayConvention,
    endOfMonthConvention: terms.endOfMonthConvention,
    feeBasis: terms.feeBasis,
    creditEventTypeCovered: terms.creditEventTypeCovered,
    currency: terms.currency,
    settlementCurrency: terms.settlementCurrency,
    statusDate: terms.statusDate,
    maturityDate: terms.maturityDate,
    purchaseDate: terms.purchaseDate,
    cycleAnchorDateOfFee: terms.cycleAnchorDateOfFee,
    notionalPrincipal: terms.notionalPrincipal,
    feeAccrued: terms.feeAccrued,
    feeRate: terms.feeRate,
    priceAtPurchaseDate: terms.priceAtPurchaseDate,
    coverageOfCreditEnhancement: terms.coverageOfCreditEnhancement,
    gracePeriod: terms.gracePeriod,
    delinquencyPeriod: terms.delinquencyPeriod,
    cycleOfFee: terms.cycleOfFee,
    contractReference_1: terms.contractReference_1,
    contractReference_2: terms.contractReference_2
});
export const extractCERTFTerms = (terms) => ({
    contractType: terms.contractType,
    calendar: terms.calendar,
    contractRole: terms.contractRole,
    dayCountConvention: terms.dayCountConvention,
    businessDayConvention: terms.businessDayConvention,
    endOfMonthConvention: terms.endOfMonthConvention,
    couponType: terms.couponType,
    currency: terms.currency,
    settlementCurrency: terms.settlementCurrency,
    statusDate: terms.statusDate,
    initialExchangeDate: terms.initialExchangeDate,
    maturityDate: terms.maturityDate,
    issueDate: terms.issueDate,
    cycleAnchorDateOfRedemption: terms.cycleAnchorDateOfRedemption,
    cycleAnchorDateOfTermination: terms.cycleAnchorDateOfTermination,
    cycleAnchorDateOfCoupon: terms.cycleAnchorDateOfCoupon,
    nominalPrice: terms.nominalPrice,
    issuePrice: terms.issuePrice,
    quantity: terms.quantity,
    denominationRatio: terms.denominationRatio,
    couponRate: terms.couponRate,
    gracePeriod: terms.gracePeriod,
    delinquencyPeriod: terms.delinquencyPeriod,
    settlementPeriod: terms.settlementPeriod,
    fixingPeriod: terms.fixingPeriod,
    redemptionRecordPeriod: terms.redemptionRecordPeriod,
    cycleOfRedemption: terms.cycleOfRedemption,
    cycleOfTermination: terms.cycleOfTermination,
    cycleOfCoupon: terms.cycleOfCoupon,
    contractReference_1: terms.contractReference_1,
    contractReference_2: terms.contractReference_2
});
export const extractCOLLATerms = (terms) => ({
    contractType: terms.contractType,
    calendar: terms.calendar,
    contractRole: terms.contractRole,
    dayCountConvention: terms.dayCountConvention,
    businessDayConvention: terms.businessDayConvention,
    endOfMonthConvention: terms.endOfMonthConvention,
    marketObjectCodeOfCollateral: terms.marketObjectCodeOfCollateral,
    currency: terms.currency,
    settlementCurrency: terms.settlementCurrency,
    collateralCurrency: terms.collateralCurrency,
    statusDate: terms.statusDate,
    initialExchangeDate: terms.initialExchangeDate,
    maturityDate: terms.maturityDate,
    capitalizationEndDate: terms.capitalizationEndDate,
    cycleAnchorDateOfInterestPayment: terms.cycleAnchorDateOfInterestPayment,
    notionalPrincipal: terms.notionalPrincipal,
    nominalInterestRate: terms.nominalInterestRate,
    accruedInterest: terms.accruedInterest,
    premiumDiscountAtIED: terms.premiumDiscountAtIED,
    coverageOfCollateral: terms.coverageOfCollateral,
    gracePeriod: terms.gracePeriod,
    delinquencyPeriod: terms.delinquencyPeriod,
    cycleOfInterestPayment: terms.cycleOfInterestPayment,
});
export const extractPAMTerms = (terms) => ({
    contractType: terms.contractType,
    calendar: terms.calendar,
    contractRole: terms.contractRole,
    dayCountConvention: terms.dayCountConvention,
    businessDayConvention: terms.businessDayConvention,
    endOfMonthConvention: terms.endOfMonthConvention,
    scalingEffect: terms.scalingEffect,
    feeBasis: terms.feeBasis,
    currency: terms.currency,
    settlementCurrency: terms.settlementCurrency,
    marketObjectCodeRateReset: terms.marketObjectCodeRateReset,
    statusDate: terms.statusDate,
    initialExchangeDate: terms.initialExchangeDate,
    maturityDate: terms.maturityDate,
    issueDate: terms.issueDate,
    purchaseDate: terms.purchaseDate,
    capitalizationEndDate: terms.capitalizationEndDate,
    cycleAnchorDateOfInterestPayment: terms.cycleAnchorDateOfInterestPayment,
    cycleAnchorDateOfRateReset: terms.cycleAnchorDateOfRateReset,
    cycleAnchorDateOfScalingIndex: terms.cycleAnchorDateOfScalingIndex,
    cycleAnchorDateOfFee: terms.cycleAnchorDateOfFee,
    notionalPrincipal: terms.notionalPrincipal,
    nominalInterestRate: terms.nominalInterestRate,
    accruedInterest: terms.accruedInterest,
    rateMultiplier: terms.rateMultiplier,
    rateSpread: terms.rateSpread,
    nextResetRate: terms.nextResetRate,
    feeRate: terms.feeRate,
    feeAccrued: terms.feeAccrued,
    premiumDiscountAtIED: terms.premiumDiscountAtIED,
    priceAtPurchaseDate: terms.priceAtPurchaseDate,
    priceAtTerminationDate: terms.priceAtTerminationDate,
    lifeCap: terms.lifeCap,
    lifeFloor: terms.lifeFloor,
    periodCap: terms.periodCap,
    periodFloor: terms.periodFloor,
    gracePeriod: terms.gracePeriod,
    delinquencyPeriod: terms.delinquencyPeriod,
    cycleOfInterestPayment: terms.cycleOfInterestPayment,
    cycleOfRateReset: terms.cycleOfRateReset,
    cycleOfScalingIndex: terms.cycleOfScalingIndex,
    cycleOfFee: terms.cycleOfFee
});
export const extractSTKTerms = (terms) => ({
    contractType: terms.contractType,
    calendar: terms.calendar,
    contractRole: terms.contractRole,
    dayCountConvention: terms.dayCountConvention,
    businessDayConvention: terms.businessDayConvention,
    endOfMonthConvention: terms.endOfMonthConvention,
    redeemableByIssuer: terms.redeemableByIssuer,
    currency: terms.currency,
    settlementCurrency: terms.settlementCurrency,
    statusDate: terms.statusDate,
    issueDate: terms.issueDate,
    purchaseDate: terms.purchaseDate,
    cycleAnchorDateOfDividend: terms.cycleAnchorDateOfDividend,
    nominalPrice: terms.nominalPrice,
    notionalPrincipal: terms.notionalPrincipal,
    issuePrice: terms.issuePrice,
    quantity: terms.quantity,
    priceAtPurchaseDate: terms.priceAtPurchaseDate,
    priceAtTerminationDate: terms.priceAtTerminationDate,
    redemptionPrice: terms.redemptionPrice,
    dividendRecordPeriod: terms.dividendRecordPeriod,
    dividendPaymentPeriod: terms.dividendPaymentPeriod,
    splitSettlementPeriod: terms.splitSettlementPeriod,
    redemptionRecordPeriod: terms.redemptionRecordPeriod,
    redemptionPaymentPeriod: terms.redemptionPaymentPeriod,
    cycleOfDividend: terms.cycleOfDividend
});
const associativeArrayToObject = (arr) => (Object.assign({}, Object.keys(arr).reduce((obj, element) => ((!Number.isInteger(Number(element)))
    ? Object.assign(Object.assign({}, obj), { [element]: (Array.isArray(arr[element]))
            ? associativeArrayToObject(arr[element])
            : arr[element] }) : obj), {})));
//# sourceMappingURL=Conversion.js.map